import { render, staticRenderFns } from "./EventParticipantsExport.vue?vue&type=template&id=5065dce0"
import script from "./EventParticipantsExport.vue?vue&type=script&lang=js"
export * from "./EventParticipantsExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports